import { useState, Fragment } from 'react';

import { Button, Box, Avatar, Menu, MenuItem, ListItemIcon, ListItemText, Divider, IconButton, Typography, Tooltip, useTheme } from '@mui/material';

import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';

import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import Face2RoundedIcon from '@mui/icons-material/Face2Rounded';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';

import AddRounded from '@mui/icons-material/AddRounded';

import { Link } from 'react-router-dom';

import useIsMobile from '../../../hooks/useIsMobile';

import { BasicFlex } from '../../../utils/Common';


const CreateNew = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { isMobile } = useIsMobile();

  const theme = useTheme();

  return (
    <Fragment>
      {isMobile ? <Avatar onClick={handleClick} sx={{ bgcolor: theme.palette.info.main }}><AddRounded /></Avatar> : <Button 
        startIcon={<AddRounded />}
        variant='outlined'
        onClick={handleClick}
        sx={{mr: "1rem"}}
      >
        Create New
      </Button>}
      <Menu
        anchorEl={anchorEl}
        id="create-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: isMobile ? "1.3rem" : "0",
              minWidth: "14rem",
            },
          },
        }}
        transformOrigin={{ horizontal: isMobile ? 'center' : 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: isMobile ? 'center' : 'left', vertical: 'bottom' }}
      >
        <MenuItem 
          component={Link}
          to="/schedule/edit"
          onClick={handleClose}
          // dense
        >
        <BasicFlex justify="flex-start" gap="1.5rem">
         <EditCalendarRoundedIcon fontSize='small' color="basic" /> Appointment
         </BasicFlex>
        </MenuItem>
        <MenuItem 
          component={Link}
          to="/invoices/edit"
          onClick={handleClose}
          // dense
        >
        <BasicFlex justify="flex-start" gap="1.5rem">
         <ReceiptRoundedIcon fontSize='small' color="basic" /> Invoice
         </BasicFlex>
        </MenuItem>
        <MenuItem 
          component={Link}
          to="/repair_tickets/edit"
          onClick={handleClose}
          // dense
        >
         <BasicFlex justify="flex-start" gap="1.5rem">
          <AutoFixHighRoundedIcon fontSize='small' color="basic" /> Repair
         </BasicFlex>
        </MenuItem>

        <MenuItem 
          component={Link}
          to="/payments/edit"
          onClick={handleClose}
          // dense
        >
         <BasicFlex justify="flex-start" gap="1.5rem">
          <MonetizationOnRoundedIcon fontSize='small' color="basic" /> Payment
         </BasicFlex>
        </MenuItem>

        <MenuItem 
          component={Link}
          to="/shipments/edit"
          onClick={handleClose}
          // dense
        >
         <BasicFlex justify="flex-start" gap="1.5rem">
          <LocalShippingRoundedIcon fontSize='small' color="basic" /> Shipment
         </BasicFlex>
        </MenuItem>

        {/* <MenuItem 
          component={Link}
          to="/service_tickets/check_in"
          onClick={handleClose}
          // dense
        >
         <BasicFlex justify="flex-start" gap="1.5rem">
          <Face2RoundedIcon fontSize='small' color="basic" /> Check In
         </BasicFlex>
        </MenuItem> */}
        
      </Menu>
    </Fragment>
  );
};

export default CreateNew;


